import * as React from 'react';
import TooltipComponent from '../../TooltipComponent';

interface ILabelProps {
  title: string;
  value: string | null | undefined | JSX.Element;
  isWithSubpage?: boolean;
  areLabels?: boolean;
  newStyle?: boolean;
  isLabelInTwoRows?: boolean;
  name?: string;
  isLong?: boolean;
  labelClassName?: string;
  valueClassName?: string;
}

const Label: React.FC<ILabelProps> = (props) => {
  let element: any = props.value;
  const regexFindColor = new RegExp(/#[0-9a-f]{6}|#[0-9a-f]{3}/gi);

  if (regexFindColor.test(String(props.value) as string)) {
    element = (
      <div
        style={{
          backgroundColor: String(props.value) || '#000',
          height: 20,
          width: 20,
          borderRadius: 5,
          border: '1px #ccc solid',
        }}
      />
    );
  }

  const oldStyleContent: JSX.Element = props.isWithSubpage ? (
    <div className={`${props.areLabels ? 'mb-1' : 'row'} form-group`}>
      <div className="text-left font-weight-bold col-sm-3">{props.title}</div>
      <div className="col-sm-9">{element}</div>
    </div>
  ) : (
    <div className={`${props.areLabels ? '' : 'row'} form-group`}>
      <div className="col-sm-3 control-label text-left font-weight-bold pt-0">{props.title}</div>
      <div className="col-sm-9">{element}</div>
    </div>
  );

  const newStyleContent: JSX.Element = props.isWithSubpage ? (
    <div className={`${props.areLabels ? 'mb-1' : 'row'} form-group`}>
      <div className="text-left font-weight-bold col-sm-3">{props.title}</div>
      <div className="col-sm-9">{element}</div>
    </div>
  ) : (
    <div className="form-group" style={{ marginBottom: '20px' }}>
      <div>
        <label
          className={`${props.labelClassName ? props.labelClassName : 'd-block form-label'}`}
          style={props.isLabelInTwoRows ? { paddingRight: '23px' } : {}}
        >
          {props.title}
        </label>

        <div className={`${props.valueClassName ? props.valueClassName : 'd-block'}`}>
          {props.isLong ? (
            <TooltipComponent
              id={props.title}
              overlay={<div style={{ color: '#fff' }}>{element}</div>}
              width="auto"
            >
              <div
                style={{
                  whiteSpace: 'nowrap',
                  width: '355px',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                }}
              >
                {element}
              </div>
            </TooltipComponent>
          ) : (
            <div id={props.name}>{element}</div>
          )}
        </div>
      </div>
    </div>
  );

  return props.newStyle ? newStyleContent : oldStyleContent;
};

export default Label;
